module.exports = __webpack_public_path__ + "static/media/loading-button.4b2dbd00.svg";